import React, {Component} from "react";
import "./AddMemberModal.scss";
import '../../styles/_layout.scss';
import {Button, CardBody, Dropdown, GdAutocomplete, Input, EditableList, GdCheckbox, StandardListCell} from "gd-react";
import GridDuck from "gridduck";
import history from "../../meta/history";
import GdModal from "../../components/GdModal/GdModal";

class AddMemberModal extends Component {

    constructor(props) {
        super(props);
        let self = this;
        this.closeModal = this.closeModal.bind(this);
        this.onFormChange = this.onFormChange.bind(this);
        this.saveChanges = this.saveChanges.bind(this);
        this.onEmailsChange = this.onEmailsChange.bind(this);
        this.chunkEmailsIntoValidInvalid = this.chunkEmailsIntoValidInvalid.bind(this);
        this.validateEmail = this.validateEmail.bind(this);
        this.getClients = this.getClients.bind(this);
        this.sitesChanged = this.sitesChanged.bind(this);
        this.onCheckboxChange = this.onCheckboxChange.bind(this);
        this.changePerm = this.changePerm.bind(this);
        this.getUserSites = this.getUserSites.bind(this);
        this.getAllSites = this.getAllSites.bind(this);
        this.errors = {};
        this.changed = false;
        this.yourOrgTitle = `Your Organisation (${window._internalCompanyName})`;

        this.state = {
            invites: {emails: [], orgPermission: 'admin'},
            loaded: false,
            emails: '',
            sitesLimitedTo: [],
            hasOrgPartners: false,
            resetActiveList: 1,
            client: {id: 'yourOrg', title: this.yourOrgTitle},
            accessLevels: [
                {
                    id: 0,
                    title: 'Owner',
                    value: 'owner',
                    rank: 0
                },
                {
                    id: 1,
                    title: 'Admin',
                    value: 'admin',
                    rank: 1
                },
                {
                    id: 2,
                    title: 'Edit',
                    value: 'edit',
                    rank: 2
                },
                {
                    id: 3,
                    title: 'Boost/Snooze',
                    value: 'boost_snooze',
                    rank: 3
                },
                {
                    id: 4,
                    title: 'View',
                    value: 'view',
                    rank: 4
                }
            ]
        }


        this.modalClosed = false;
    }

    async componentDidMount() {
        const orgPartners = await GridDuck.getOrgPartners({
            items: 1, offset: 0, filters: [{field: 'type', value: 'customer'},
                {field: 'owner', value: true}]
        });
        if (parseInt(orgPartners.total)) {
            this.setState({hasOrgPartners: true});
        }
    }

    async getUserSites(params) {
        return Promise.resolve({list: this.state.sitesLimitedTo, total: this.state.sitesLimitedTo.length})
    }

    // async getAllSites(params) {
    //     const sites = await GridDuck.getSites(params);
    //     sites.list.map(site => {
    //         site.userPermName = 'view'
    //         return site;
    //     })
    //     return sites;
    // }

    async getAllSites(params) {
        if (!params.filters) params.filters = [];
        let sitesRes = await GridDuck.getSites(params);

        // let permLevel = this.state.invites.orgPermission === 'owner' ? 'admin' : this.state.invites.orgPermission;
        let permLevel = 'view';
        // Map and filter sites
        sitesRes.list = sitesRes.list.map((s) => {
            return {
                siteId: s.id,
                id: s.id,
                name: s.name,
                orgPermName: permLevel,
                userPermName: permLevel,
                orgPermRank: this.state.accessLevels?.find((p) => p.value === permLevel)?.rank,
            };
        });

        return Promise.resolve(sitesRes);
    }

    sitesChanged(a, b, itemsToAddRemove) {
        let newSites = this.state.sitesLimitedTo.filter(site => !itemsToAddRemove.itemsToRemove.find(i => i.id === site.id)).concat(itemsToAddRemove.itemsToAdd);
        this.setState({sitesLimitedTo: newSites, formUpdated: true, sitesChanged: true})
    }

    onCheckboxChange(val) {
        this.state[val.target.name] = val.target.checked
        this.setState(this.state);
    }

    changePerm(val, item) {
        let element = this.state.sitesLimitedTo.find((s) => s.id === item.id)
        const perm = this.state.accessLevels.find((s) => s.value === val.target.value)
        element.userPermName = val.target.value;
        element.orgPermName = perm.value;
        element.orgPermRank = perm.rank;
        this.state.sitesChanged = true;
        this.setState(this.state)
    }


    async getClients(searchTerm, reset, offset) {
        let self = this
        let filters = [{field: 'type', value: 'customer'},
            {field: 'owner', value: true}, {
                field: 'search',
                value: searchTerm
            }]
        let orgPartnersRes = await GridDuck.getOrgPartners({filters: filters, offset: this.siteOffset})
        let orgPartners = [{id: 'yourOrg', title: this.yourOrgTitle}].concat(orgPartnersRes.list
            .map(
                o => ({
                    id: o.id,
                    orgToId: o.orgToId,
                    title: o.orgToName
                })
            ))
        return Promise.resolve({
            items: orgPartners,
            offset: offset,
            count: orgPartnersRes.count
        });
    }

    closeModal() {
        this.modalClosed = true;
        this.props.onClose();
    }

    onFormChange(val) {
        this.state.invites[val.target.name] = val.target.value;
        const currentOrgPerm = this.state.accessLevels?.find((p) => p.value === this.state.invites.orgPermission);
        let sitePerm = currentOrgPerm;
        if (currentOrgPerm === 0) {
            sitePerm = this.state.accessLevels[1];
        }
        if (this.state.sitesLimitedTo.length && sitePerm) {
            this.state.sitesLimitedTo.forEach((s) => {
                if (s.orgPermRank < sitePerm.rank) {
                    s.orgPermName = sitePerm.value;
                    s.userPermName = sitePerm.value;
                    s.orgPermRank = sitePerm.rank;
                }
            });
        }
        this.setState({invites: this.state.invites, sitesLimitedTo: this.state.sitesLimitedTo});
    }

    onEmailsChange(val) {
        let emailsSeparated = this.chunkEmailsIntoValidInvalid(val.target.value);
        let invites = this.state.invites;
        invites.emails = emailsSeparated.validEmails;
        this.setState({emails: val.target.value, invites: invites, processed: emailsSeparated});
    }

    saveChanges() {
        let self = this;
        this.setState({triedToSave: true})
        let emails = this.state.processed;

        let promises = [];
        const uniqueSitePerms = [
            ...new Map(
                self.state.sitesLimitedTo.map((s) => {
                    s.orgPermRank = self.state.accessLevels?.find(
                        (p) => p.value === s.userPermName
                    )?.rank;
                    return [s.id, s];
                })
            ).values(),
        ];

        if (!this.state.emails.length) {
            this.errors['emails-empty'] = true;
            return Promise.reject();
        }

        if (emails.invalidEmails.length) {
            let invalidEmails = emails.invalidEmails.map(function (invalidEmail, i) {
                return <span key={i}
                             className={'invalid-emails'}>{invalidEmail}{i !== emails.invalidEmails.length - 1 ? ',' : ''} </span>
            })
            this.setState({invalidEmails: invalidEmails})
            this.errors['emails-invalid'] = true;
            return Promise.reject();
        }

        this.state.invites.emails.forEach(function (email) {
            promises.push(GridDuck.createOrganisationInvite({
                orgPermission: self.state.invites.orgPermission,
                emailAddress: email,
                orgId: self.state.client?.id !== 'yourOrg' ? self.state.client?.orgToId : null,
                orgOverridePerms: self.state.orgOverridePerms,
                sitesLimitedTo: self.state.orgOverridePerms ? uniqueSitePerms : null
            }));
        })

        return Promise.all(promises).then(function () {

            let toastText = (self.state.invites.emails.length + ' Invite' + (self.state.invites.emails.length > 1 ? 's' : '') + ' Sent');
            // 
            history.push({
                pathname: '/organisation/invites',
                state: {
                    showToast: toastText.toString()
                }
            })
            self.state.invitesSent = true;
            self.closeModal();
            return Promise.resolve();
        }).catch(function (err) {

            return Promise.reject();
        });


    }

    validateEmail(email) {
        let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }

    chunkEmailsIntoValidInvalid(emails) {
        let self = this;
        let parsedEmails = {
            validEmails: [],
            invalidEmails: []
        };

        let emailArray;

        emailArray = emails.split(',');
        emailArray = emailArray.map(function (email) {
            return email.replace(/\s/g, '');
        });

        emailArray.forEach(function (email) {
            if (self.validateEmail(email)) parsedEmails.validEmails.push(email);
            else parsedEmails.invalidEmails.push(email);
        });

        return parsedEmails
    }

    // checkErrors() {
    //     let errors = {};
    //     if (!this.state.site || !this.state.site.id) errors['site'] = true;
    //     if (!this.state.hubsToAdd || !this.state.hubsToAdd.length) errors['hubs'] = true;
    //     this.errors = errors;
    // }

    render() {
        let self = this;
        let footer;
        footer = <Button label={'Send Invite/s'} additionalclasses={'sm'}
                         progressRes={true}
                         color={'gd-green'}
                         onClick={this.saveChanges}/>;
        return (
            <GdModal
                title={"Invite Organisation Members"}
                open={this.props.open}
                wide={this.state.orgOverridePerms}
                footer={footer}
                contentLabel={'Invite Organisation Members'}
                onClose={this.closeModal}>
                <CardBody>
                    {/*If they have clients then add a dropdown showing the clients*/}
                    {this.state.hasOrgPartners ? <div>
                        <GdAutocomplete
                            async
                            lazyload
                            getListPaginated={this.getClients}
                            name={'site'}
                            getOptionSelected={function (option, value) {
                                if (option && value) return option.id === value.id;
                            }}
                            value={this.state.client}
                            placeholder={'Select an organisation'}
                            onChange={(val, obj) => this.setState({client: obj, sitesLimitedTo: [], resetActiveList: self.state.resetActiveList += 1})}
                            label="Invite to Organisation"/>
                    </div> : null}

                    <div style={{marginBottom: '5px'}}>
                        <Input multiline required
                               error={(this.errors['emails-empty'] || this.errors['emails-invalid']) && this.state.triedToSave}
                               autoFocus
                               onChange={this.onEmailsChange}
                               name={'name'} value={this.state.emails}
                               inputProps={{minRows: 3, maxRows: 4}}
                               label={'Enter email addresses separated by a comma (,)'}/>
                        {this.errors['emails-invalid'] ? <p className={'error-text'}>
                            The following emails {this.state.invalidEmails} were invalid
                        </p> : ''}
                    </div>
                    <div style={{marginBottom: '5px'}}>
                        <Dropdown name={'orgPermission'} value={this.state.invites.orgPermission}
                                  onChange={this.onFormChange}
                                  label={'Organisation Access Level'} fixeditems={self.state.accessLevels}/>
                    </div>
                    <div className={'override-row'}>
                        <GdCheckbox checked={this.state.orgOverridePerms}
                                    name={'orgOverridePerms'}
                                    onChange={this.onCheckboxChange}
                                    label={'Limit Access to Only Selected Sites'}/>

                    </div>
                    {this.state.orgOverridePerms ? <EditableList
                        key={1}
                        noCancel
                        activeRowHeight={'60px'}
                        noSave
                        isEditing
                        activeFilters={[{
                            field: 'reset',
                            value: this.state.resetActiveList
                        }]}
                        availableFilters={[{
                            field: 'orgPartnerId',
                            value: this.state.client?.id !== 'yourOrg' ? this.state.client?.id : null
                        }]}
                        activeColumns={[{
                            component: StandardListCell,
                            maxWidth: 'none',
                            title: 'Name',
                            custom: function (item) {
                                return <div>
                                    <p className={'name'} style={{marginTop: 0}}>{item.name}</p>
                                </div>
                            }
                        }, {
                            component: StandardListCell,
                            maxWidth: '150px',
                            title: 'Access',
                            custom: function (item) {
                                return <div>
                                    <Dropdown onChange={(val) => self.changePerm(val, item)}
                                              value={item.userPermName}
                                              placeholder={'Select Permission Level'}
                                              fixeditems={self.state.accessLevels.filter((p) => !(p.rank < self.state.accessLevels.find(al => al.value === self.state.invites.orgPermission).rank) && p.rank !== 0)}/>
                                </div>
                            }
                        },]}
                        getActiveList={this.getUserSites}
                        getAvailableList={this.getAllSites}
                        onChange={this.sitesChanged}
                    /> : null}

                </CardBody>
            </GdModal>
        )
    }
}

export default AddMemberModal;
